import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

// Get all clients
const getClients = async () => {
  const response = await axios.get(`${base_url}client/`);
  return response.data;
};

// Create a new client
const createClient = async (client) => {
  const response = await axios.post(`${base_url}client/`, client,);
  return response.data;
};

// Update client by slug
// service
export const updateClient = async (client) => {
  const response = await axios.put(
    `${base_url}client/${client.id}`, // use id here
    {
      title: client.clientData.title,
      images: client.clientData.images,
    },
    config
  );
  return response.data;
};

// Get single client by ID
const getClient = async (id) => {
  const response = await axios.get(`${base_url}client/${id}`, config);
  return response.data;
};

// Delete client by slug
const deleteClient = async (slug) => {
  const response = await axios.delete(`${base_url}client/${slug}`, config);
  return response.data;
};

const clientService = {
  getClients,
  createClient,
  getClient,
  updateClient,
  deleteClient,
};

export default clientService;
